import { render, staticRenderFns } from "./StepStima.vue?vue&type=template&id=45d8196a&scoped=true"
import script from "./StepStima.vue?vue&type=script&lang=js"
export * from "./StepStima.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d8196a",
  null
  
)

export default component.exports